<template>
  <v-dialog scrollable v-model="config.status.active" max-width="800px">
    <v-card class="dialog">
      <v-card-title class="primary pa-0">
        <v-toolbar flat v-if="config.status.importing" class="blue darken-2 white--text">
          <v-toolbar-title class="headline">ライブラリ</v-toolbar-title>
        </v-toolbar>
        <v-toolbar flat v-else class="amber blue-grey--text text--darken-4">
          <v-toolbar-title class="headline">申込確認</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn depressed v-if="isAuthed"
            color="blue darken-2 white--text"
            :disabled="isLoading && !isSetMediaId"
            @click.stop="openMedia"
          ><font-awesome-icon :icon="['fas', 'file-import']"></font-awesome-icon>&nbsp;ライブラリから追加する</v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-row dense>
              <v-col cols="12" v-if="!isImporting">
                <v-menu lazy offset-y full-width
                  v-if="isAuthed"
                  v-model="config.datepickers.date"
                  transition="scale-transition"
                  min-width="290px"
                  :close-on-content-click="false"
                  :nudge-right="40"
                >
                  <v-text-field readonly
                    v-model="printFormDate"
                    slot="activator"
                    label="完了日付"
                  />
                  <v-date-picker
                    v-model="form.date"
                    locale="ja"
                    color="amber"
                    :day-format="date => new Date(date).getUTCDate()"
                    @input="config.datepickers.date = false"
                  />
                </v-menu>
                <v-text-field readonly
                  v-else
                  v-model="printFormDate"
                  label="完了日付"
                />
              </v-col>
              <v-col cols="12">
                <ClientFiler v-if="form.mid" ref="filer"
                  :rid="form.mid"
                  :permits="{
                    add: isAuthed,
                    modify: isAuthed,
                    trash: true
                  }"
                  @select="selectImports"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions v-if="!isImporting">
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed v-if="isAuthed" color="secondary white--text" @click.stop="submit" :loading="isLoading">保存する</v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-btn text color="secondary" @click="closeMedia">ライブラリを閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed
          color="secondary white--text"
          :loading="isLoading"
          :disabled="!form.import"
          @click.stop="importItems"
        >追加する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ClientFiler from '@/components/filers/client'
export default {
  name: 'authorStaysModalsApp',
  components: {
    ClientFiler
  },
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          importing: false
        },
        datepickers: {
          date: false
        }
      },
      form: {
        valid: true,
        id: '',
        cid: '',
        clientId: '',
        authed: false,
        date: '',
        owner: '',
        house: {
          name: '',
          in: '',
          out: ''
        },
        import: false
      },
      store: {
        lib: {},
        imports: []
      },
      rules: {
        date: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'progs/update/item/meta', {
            id: this.form.id,
            cid: this.form.cid,
            type: 'stay.app',
            form: {
              content: this.form.date,
              option: {
                owner: this.form.owner,
                house: {
                  name: this.form.house.name,
                  in: this.form.house.in,
                  out: this.form.house.out
                }
              }
            }
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('done', {
                id: this.form.cid,
                type: 'app',
                value: {
                  date: this.form.date,
                  owner: this.form.owner,
                  house: {
                    name: this.form.house.name,
                    in: this.form.house.in,
                    out: this.form.house.out
                  }
                }
              })
              this.close()
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    importItems: function () {
      if (this.form.import && this.store.imports.length) {
        this.$set(this.config.status, 'loading', true)
        let items = this.store.imports.filter(it => {
          return (it.type === 'file')
        })
        if (items.length) {
          this.$firebase.auth().currentUser.getIdToken(true).then(token => {
            this.axios.post(this.$url.api + 'box/copy/' + this.form.mid, {
              items: items
            }, {
              headers: {
                'firebase-token': token
              }
            }).then(res => {
              console.log(res)
              if (res.data && res.data.success) {
                this.closeMedia()
              } else if (
                res.data &&
                res.data.data &&
                res.data.data.response &&
                res.data.data.response.body &&
                res.data.data.response.body.code
              ) {
                let code = res.data.data.response.body.code
                let err = this.$error.box.item.move[code] ? this.$error.box.item.move[code] : ''
                if (err) {
                  this.$store.dispatch('notifier/addAlert', {
                    title: 'インポート失敗',
                    message: err
                  })
                }
              }
              this.$set(this.config.status, 'loading', false)
            }).catch(err => {
              console.log(err)
              this.$set(this.config.status, 'loading', false)
            })
          })
        }
      }
    },
    open: function (val) {
      const { id, cid, clientId, authed, mid, date, owner, house } = val
      this.$set(this.config.status, 'active', true)
      this.$set(this, 'form', {
        valid: true,
        id: id,
        cid: cid,
        clientId: clientId,
        authed: authed,
        mid: mid,
        date: date,
        owner: owner,
        house: house,
        import: false
      })
      if (clientId) {
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'box/get/root/' + clientId, {
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$set(this.store, 'lib', res.data.data)
            }
          }).catch(err => {
            console.log(err)
          })
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$set(this.store, 'lib', {})
      }
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    openMedia: function () {
      this.$set(this.config.status, 'importing', true)
      this.$refs.filer.init({ rid: this.store.lib.media })
    },
    closeMedia: function () {
      this.$set(this.config.status, 'importing', false)
      this.$refs.filer.init({ rid: this.form.mid })
    },
    selectImports: function (items) {
      if (this.config.status.importing) {
        let selects = items ? items.filter(it => {
          return (it.id && it.type && it.type !== 'folder')
        }) : this.store.items
        this.$set(this.store, 'imports', selects)
        this.$set(this.form, 'import', !!selects.length)
      } else {
        this.$set(this.form, 'import', false)
      }
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    isAuthed () {
      return this.form.authed
    },
    isImporting () {
      return this.config.status.importing
    },
    isSetMediaId () {
      return this.store.lib.media
    },
    printFormDate () {
      return (this.form.date) ? this.$moment(this.form.date).format('YYYY/MM/DD') : ''
    }
  }
}
</script>
